exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cat__app-loader {\r\n  width: 44px;\r\n  height: 44px;\r\n  border-radius: 40px;\r\n\r\n  position: fixed;\r\n  z-index: 1100;\r\n\r\n  top: 50%;\r\n  left: 50%;\r\n  margin-left: -20px;\r\n  margin-top: -50px;\r\n\r\n  background: #F6D000;\r\n  background: linear-gradient(135deg,  #F6D000 0%,#343C49 80%);\r\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#F6D000', endColorstr='#343C49',GradientType=1 );\r\n\r\n  animation: rotating 1s linear infinite;\r\n}\r\n\r\n.cat__app-loader div {\r\n  background: #f2f4f8;\r\n  width: 34px;\r\n  height: 34px;\r\n  border-radius: 30px;\r\n  margin: 5px;\r\n}\r\n\r\n@keyframes rotating {\r\n  from {\r\n    transform: rotate(0deg);\r\n  }\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!./src/assets/preloader.css
// module id = ./node_modules/css-loader/index.js?{"sourceMap":false,"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!./src/assets/preloader.css
// module chunks = styles